<template>
  <div class="pageBox">
    <div class="content-block">
      <h3 class="title text-center">账号信息</h3>
      <el-form :model="form"  ref="form" label-width="auto" class="infoForm">
				<div class="subTitle">开发者类型</div>
				<hr class="hr">
				<el-row>
          <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
            <el-form-item label="开发者类型" prop="type">
              <el-radio-group
                aria-label="开发者类型"
                aria-autocomplete="none"
                placeholder="请勾选开发者类型"
                type="text"
                v-model="form.type"
                disabled
              >
                <el-radio v-if="form.type==1" :label="1">企业</el-radio>
                <el-radio v-if="form.type==2" :label="2">个人</el-radio>
								<el-radio v-if="form.type==3" :label="3">政府机构</el-radio>
								<el-radio v-if="form.type==4" :label="4">事业单位</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="subTitle">基本信息</div>
				<hr class="hr">
        <template v-if="form.type === 2">
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="姓名" prop="name">
                <el-input
                    aria-label="姓名"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请填写姓名"
                    type="text"
                    disabled
                    v-model.trim="form.name"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="身份证号码" prop="developId">
                <el-input
                    aria-label="身份证号码"
                    aria-autocomplete="none"
                    clearable
                    maxlength="100"
                    placeholder="请填写身份证号码"
                    type="text"
                    disabled
                    v-model.trim="form.developId"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="证件有效起止时间" prop="developIdValidityStart">
                <el-date-picker
                    v-model="form.developIdValidityStart"
                    type="date"
                    disabled
                    value-format="timestamp"
                    placeholder="选择日期">
                </el-date-picker>
                至
                <el-date-picker
                    v-model="form.developIdValidityEnd"
                    type="date"
                    disabled
                    value-format="timestamp"
                    placeholder="选择日期">
                </el-date-picker>
                <div class="themeColor">有效期为“长期”时后一项为空</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <div class="flex">
                <el-form-item label="身份证" prop="developPositivePhoto">
                  <el-upload
                      disabled
                      class="uploaderFile"
                      accept=".png, .PNG"
                      :action="configBaseURL+'/api/uploadFile'"
                      :data="{type:'developPhoto'}"
                      :show-file-list="false"
                      :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'developPositivePhoto')}"
                      :before-upload="beforeUpload"
                  >
                    <img
                        v-if="form.developPositivePhoto"
                        class="file"
                        :src="form.developPositivePhoto"
                    />
                    <i v-else class="el-icon-plus icon idCardBackImg"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item prop="developNegativePhoto" label-width="10px">
                  <el-upload
                      disabled
                      class="uploaderFile"
                      accept=".png, .PNG"
                      :action="configBaseURL+'/api/uploadFile'"
                      :data="{type:'developPhoto'}"
                      :show-file-list="false"
                      :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'developNegativePhoto')}"
                      :before-upload="beforeUpload"
                  >
                    <img
                        v-if="form.developNegativePhoto"
                        class="file"
                        :src="form.developNegativePhoto"
                    />
                    <i v-else class="el-icon-plus icon IDcardFrontImg"></i>
                  </el-upload>
                </el-form-item>
              </div>
              <el-form-item>
                <div class="themeColor">请上传证件正反面图片，图片格式为png，大小不能超过2M。</div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="企业名称" prop="companyName">
                <el-input
                    aria-label="企业名称"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请输入企业或公司名称"
                    type="text"
                    v-model.trim="form.companyName"
                    disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="统一信用社会代码" prop="licinseNumber">
                <el-input
                    aria-label="统一信用社会代码"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请输入统一信用社会代码"
                    type="text"
                    v-model.trim="form.licinseNumber"
                    disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.type==1" >
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="营业执照" prop="licinseNumberPhoto">
                <el-upload
                    class="uploaderFile"
                    accept="image/png, image/PNG"
                    :action="configBaseURL+'/api/upload'"
                    :data="{type:'account'}"
                    :show-file-list="false"
                    :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'licinseNumberPhoto')}"
                    :before-upload="beforeUpload"
                    disabled
                >
                  <img v-if="form.licinseNumberPhoto" class="file" :src="form.licinseNumberPhoto" />
                  <i v-else class="el-icon-plus icon businessBeforeImg"></i>
                </el-upload>
                <div class="themeColor">图片支持jpg、png格式，大小不能超过2M。</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.type==3" >
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="统一社会信用代码证书" prop="licinseNumberPhoto">
                <el-upload
                    class="uploaderFile"
                    accept="image/png, image/PNG"
                    :action="configBaseURL+'/api/upload'"
                    :data="{type:'account'}"
                    :show-file-list="false"
                    :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'licinseNumberPhoto')}"
                    :before-upload="beforeUpload"
                    disabled
                >
                  <img v-if="form.licinseNumberPhoto" class="file" :src="form.licinseNumberPhoto" />
                  <i v-else class="el-icon-plus icon businessBeforeImg"></i>
                </el-upload>
                <div class="themeColor">图片支持jpg、png格式，大小不能超过2M。</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.type==4" >
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="事业法人证书" prop="licinseNumberPhoto">
                <el-upload
                    class="uploaderFile"
                    accept="image/png, image/PNG"
                    :action="configBaseURL+'/api/upload'"
                    :data="{type:'account'}"
                    :show-file-list="false"
                    :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'licinseNumberPhoto')}"
                    :before-upload="beforeUpload"
                    disabled
                >
                  <img v-if="form.licinseNumberPhoto" class="file" :src="form.licinseNumberPhoto" />
                  <i v-else class="el-icon-plus icon businessBeforeImg"></i>
                </el-upload>
                <div class="themeColor">图片支持jpg、png格式，大小不能超过2M。</div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
				<el-row>
					<el-col :span="16" :offset="4" :xs="{span:22,offset:0}" >
						<div class="flex">
							<el-form-item label="所属区域" prop="province" label-width="120px">
								<el-select v-model="form.province" placeholder="请选择" @change="selectProvince" disabled style="width: 120px" size="small">
									<el-option
										v-for="(item,index) in provincearr"
										:key="index"
										:label="item.name"
										:value="item.id"
										
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="city" label-width="10px">
								<el-select v-model="form.city" placeholder="请选择" @change="selectcity" disabled style="width: 120px;" size="small">
									<el-option 
									v-for="(item,index) in cityarr" 
									:key="index" 
									:label="item.name" 
									:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="area" label-width="10px">
								<el-select v-model="form.area" placeholder="请选择" @change="selectCountry" disabled  style="width: 120px" size="small">
									<el-option
										v-for="(item,index) in regionarr"
										:key="index"
										:label="item.name"
										:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
						<el-form-item label="通讯地址" prop="address">
							<el-input
								aria-label="通讯地址"
								aria-autocomplete="none"
								clearable
								placeholder="请填写实际通讯地址，填写格式：xx省xx市xx区xx号"
								type="text"
								v-model.trim="form.address"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
        <template v-if="form.type !== 2">
          <div class="subTitle">法人信息</div>
          <hr class="hr">
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="法人姓名" prop="legalPersonName">
                <el-input
                    aria-label="法人姓名"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请填写法人姓名"
                    type="text"
                    v-model.trim="form.legalPersonName"
                    disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="法人证件类型" prop="showLegalPersonCertificateType">
                <el-input
                    aria-label="法人证件类型"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请填写法人证件类型"
                    type="text"
                    v-model.trim="form.showLegalPersonCertificateType"
                    disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="法人证件号码" prop="legalPersonCardName">
                <el-input
                    aria-label="法人证件号码"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请填写法人证件号码"
                    type="text"
                    v-model.trim="form.legalPersonCardName"
                    disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="证件有效起止时间" prop="legalPersonCardvalidityStart">
                <el-date-picker
                    v-model="form.legalPersonCardvalidityStart"
                    type="date"
                    disabled
                    placeholder="选择日期">
                </el-date-picker>
                至
                <el-date-picker
                    v-model="form.clegalPersonCardvalidityEnd"
                    type="date"
                    disabled
                    placeholder="选择日期">
                </el-date-picker>
                <div class="themeColor">有效期为“长期”时后一项为空</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <div class="flex">
                <el-form-item label="法人证件照" prop="legalPersonPositivePhoto">
                  <el-upload
                      class="uploaderFile"
                      accept="image/png, image/PNG"
                      :action="configBaseURL+'/api/upload'"
                      :data="{type:'account'}"
                      :show-file-list="false"
                      disabled
                      :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'legalPersonPositivePhoto')}"
                      :before-upload="beforeUpload"
                  >
                    <img
                        v-if="form.legalPersonPositivePhoto"
                        class="file"
                        :src="form.legalPersonPositivePhoto"
                    />
                    <i v-else class="el-icon-plus icon idCardBackImg"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item prop="legalPersonNegativePhoto" label-width="10px">
                  <el-upload
                      class="uploaderFile"
                      accept="image/png, image/PNG"
                      :action="configBaseURL+'/api/upload'"
                      :data="{type:'account'}"
                      :show-file-list="false"
                      disabled
                      :on-success="(res,file,filelist)=>{return handleUpload(res,file,filelist,'legalPersonNegativePhoto')}"
                      :before-upload="beforeUpload"
                  >
                    <img
                        v-if="form.legalPersonNegativePhoto"
                        class="file"
                        :src="form.legalPersonNegativePhoto"
                    />
                    <i v-else class="el-icon-plus icon IDcardFrontImg"></i>
                  </el-upload>
                </el-form-item>
              </div>
              <el-form-item>
                <div class="themeColor">请上传证件正反面图片，图片格式为png，大小不能超过2M。</div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
				<div class="subTitle">联系人信息</div>
				<hr class="hr">
				<el-row>
					<el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
						<el-form-item label="联系人姓名" prop="contactName">
							<el-input
								aria-label="联系人姓名"
								aria-autocomplete="none"
								clearable
								placeholder="请输入联系人姓名"
								type="text"
								v-model.trim="form.contactName"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
						<el-form-item label="联系人手机号码" prop="contactPhone">
							<el-input
								aria-label="联系人手机号码"
								aria-autocomplete="none"
								clearable
								placeholder="请输入联系手机号码"
								type="text"
								v-model.trim="form.contactPhone"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
						<el-form-item label="联系人邮箱地址" prop="contactEmail">
							<el-input
								aria-label="联系人邮箱地址"
								aria-autocomplete="none"
								clearable
								placeholder="请输入联系人邮箱地址，不超过128个字符"
								type="email"
								v-model.trim="form.contactEmail"
								onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')" 
								disabled
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
		
				<el-row>
					<el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
						<el-form-item label="联系人微信账号" prop="weixin">
							<el-input
								aria-label="联系人微信账号"
								aria-autocomplete="none"
								clearable
								placeholder="请输入联系人微信账号"
								type="text"
								v-model.trim="form.weixin"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("accountStore/updateUserData", {}).then((res) => {
      //去后台拿用户资料，更新本地状态
      if (res.code == 0) {
        this.form = Object.assign(this.form, $utils.deepClone(res.data));
      } else {
        this.$message.error("获取资料失败");
      }
    });
  },
  data() {
    return {
      form: {
				    //开发者类型
        type: "", //1 企业 2 个人 3 事业单位  4事业单位
        //基本信息
        companyName: "", //企业名称
        licinseNumber: "", //统一社会信用代码
        licinseNumberPhoto: "", //	营业执照扫描件/证书
        province:"",//省
        city:"",//市
        area:"",//区
        address: "", //通讯地址
        developPositivePhoto: "", //开发者身份证正面
        developNegativePhoto: "", //开发者身份证反面
        developHoldPhoto: "", //开发者手持身份证
        //法人信息
        legalPersonName: "", //法人姓名
        legalPersonCardName: "", //法人身份证号
        legalPersonCardvalidityStart:"",//法人身份证有效期开始时间
        clegalPersonCardvalidityEnd:"",//法人身份证有效期结束时间  长期为空
        legalPersonPositivePhoto: "", //法人身份证正面照片
        legalPersonNegativePhoto: "", //法人身份证反面照片
        //联系人信息
        contactName:"",//联系人姓名
        contactPhone:"",//联系人电话
        contactEmail:"",//联系人邮箱
        weixin:"",//联系人微信
			},

    };
  },
  methods: {
   
  },
};
</script>

<style scoped lang="scss">
.pageBox {
  .content-block {
    padding: 50px 0;
    width: 992px;
    .title {
      position: relative;
      margin: 50px 0;
      font-size: 24px;
    }
    .infoForm {
      padding: 50px 20px;
      background: #fff;
			.subTitle{
				color: #9b9a9a;
				margin-bottom:15px ;
				
			}
			.hr{
				margin-bottom: 20px;
			}
    }
  }
}
</style>
